import { Navigate, Outlet } from "react-router-dom";

export default function ProtectedRoute({user}) {
    if(user?.data.length === 0) {
        return <Navigate to={'/login'} replace />
    }
    if(!user.payment.status) {
        return <Navigate to={'/payment'} replace />
    }

    return <Outlet />;
}